export enum ReadOnlyReason {
	Anonymous = 'anonymous',
	Unlicensed = 'unlicensed',
}
